<!--  -->
<template>
  <div class="pb100 history">
    <div class="innerbanner">
      <img src="../../assets/common/images/declarebanner.jpg" alt="">
    </div>
    <crumbs/>
  <div class="containers">
     <nodata v-show="nodataflag"/>
      <el-collapse accordion>
        <el-collapse-item v-for="item in recordList" :key="item.id">
            <template slot="title">
                <div class="itemtxt clearfix">
                     <h2>{{item.projectName}}</h2>
                    <span>{{item.insertTime.split(' ')[0]}}</span>
                    <h4>详情</h4>
                </div>
            </template>
          <div class="hisdetail">
              <dl>
                  <dt>项目名称</dt><dd>{{item.projectName}}</dd>
              </dl>
              <dl>
                  <dt>属地</dt><dd>{{item.territorial}}</dd>
              </dl>
              <dl>
                  <dt>保护单位</dt><dd>{{item.protectionUnit}}</dd>
              </dl>
              <dl>
                  <dt>通讯地址</dt><dd>{{item.mailingAddress}}</dd>
              </dl>
              <dl>
                  <dt>电子邮箱</dt><dd>{{item.email}}</dd>
              </dl>
              <dl>
                  <dt>单位电话</dt><dd>{{item.workPhone}}</dd>
              </dl>
              <dl>
                  <dt>附件</dt><dd><a href="javascript:;" @click="downLoadUrl(item.attachment)">下载附件</a></dd>
              </dl>
              <dl v-if="item.rejectFlag === 1">
                    <dt style="color:red">被驳回</dt><dd style="color:red">{{item.reject}}</dd>
              </dl>
          </div>
        </el-collapse-item>
      </el-collapse>
  </div>
  <el-pagination
      @current-change="handleCurrentChange"
      :page-size="params1.limit"
      :pager-count="5"
      :current-page.sync="currentPage"
      layout="prev, pager, next"
      :total="totalSize"
      class="pagemodel1">
    </el-pagination>
  </div>
</template>

<script>
import crumbs from '@/components/crumbs/index'
import banner from '@/components/banner/index'
import nodata from '@/components/nodata/index'
import {getRecordList} from '@/api/declare/index'
export default {
  name: 'declerahistorydetail',
  meta: {
    showHeader: true
  },
  components: {
    crumbs,
    banner,
    nodata
  },
  data () {
    return {
      params1: {
        menuId: '',
        page: 1,
        limit: 10,
        declareId: ''
      },
      id: '',
      menuId: '',
      recordList: [],
      currentPage: 1,
      nodataflag: false,
      totalSize: 0
    }
  },
  created () {
    this.id = this.$route.query.id
    this.menuId = this.$route.query.columnId
    this.params1.menuId = this.$route.query.columnId
    this.params1.declareId = this.$route.query.id
    this.getRecordList()
  },
  methods: {
    getRecordList () {
      getRecordList(this.menuId, this.params1).then(res => {
        console.log(res, 'record')
        this.recordList = res.data.data
        this.totalSize = res.data.totalSize
        if (res.data.totalSize === 0) {
          this.nodataflag = true
        } else {
          this.nodataflag = false
        }
      })
    },
    handleCurrentChange (val) {
      this.params1.page = val
      this.getRecordList()
    },
    downLoadUrl (url) {
      if (url === undefined || url === '') {
        this.$message({
          message: '没有可下载附件',
          type: 'fail'
        })
      } else {
        window.open(url)
        // const ele = document.createElement('a')
        // ele.setAttribute('href', url) // 设置下载文件的url地址
        // ele.setAttribute('download', 'download')// 用于设置下载文件的文件名
        // ele.click()
      }
    }
  },
  beforeDestroy () {

  }
}

</script>

<style lang='scss' scoped>
@import '../../assets/common/scss/declare.scss';
</style>



// WEBPACK FOOTER //
// src/view/managementdeclaration/history.vue